import { LegalCaseState, Prematter, PrematterType } from '@law-connect/types';

export const DEFAULT_PREMATTER: Prematter = {
  id: null,
  language: undefined,
  context: {
    name: '',
    form: null,
    location: null,
    questions: [],
    matterTypes: [],
  },
  reportCompletionPercentage: 0,
  messages: [],
  createdAt: Date.now(),
  state: LegalCaseState.MatterTypes,
  updatedAt: Date.now(),
  type: PrematterType.LegalInformation
};
